require('../../../libs/backbone/backbone.ajaxq.adapter.ts');
var GenericView = require('../generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/preparations/preparations.template.html');
var Table = require('text-loader!../../templates/preparations/preparations_table.template.html');
var Collection = require('../../models/preparations/preparations.paginated.collection.ts');

var Model = require('../../models/preparations/preparations.model.ts');
require('dhtmlxMessage');
var Pagination = require('../pagination.view.ts');
var HandlebarsHelpers = require('../../../libs/handlebars/handlebars-helpers.ts');
require('../../../libs/bootstrap/js/bootstrap-table.js');
var i18n = require("l10n");
var popup = require('popup');
require('jqueryUI');
var PreparationRowPartialTemplate = require('text-loader!../../templates/preparations/preparationRow.partial.template.html');
var PreparationPopupTemplate = require('text-loader!../../templates/counter/preparationPopup.template.html');

var PreparationsPopupView = require("./preparationsPopup.view.ts")

var SockJS = require('sockjs-client');
var Stomp = require('stompjs');


var TheView = GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	preparationRowPartialTemplate: Handlebars.compile(PreparationRowPartialTemplate),
	preparationPopupTemplate: Handlebars.compile(PreparationPopupTemplate),
	progressTemplate: Handlebars.compile("{{> progressPartial}}"),
	table: Handlebars.compile(Table),
	superInitialize: GenericView.prototype.initialize,
	collection: null,
	model: null,
	isFirstDisplay: true,
	lastSearchedText: "",
	stompSubscription: null,
	initialize: function () {
		var self = this;

        $(window).off("popstate").on("popstate", function() {
            self.clearListener();
        });

        this.wsocket = new SockJS('rest/live');
        this.client = Stomp.over(this.wsocket);

		this.collection = new Collection();
		this.collection.state.pageSize = 999;
		this.collection.on( 'sync', this.successData, this );
		this.collection.on( 'error', this.errorData, this );

		this.collection.url = '/rest/api/preparations/withTickets';
		this.collection.getFirstPage();

		this.clearListener(); // clear stomp listener
		this.setListener(); // set stomp listener
	},
	superRender:  GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

		this.$el.html(this.template());
	},
	events: {

	},
	setCountdownForElement: function(dateFrom, elem) {
        var self = this;

        //pass a `dateFrom`, in case the timer has already begun and for some reason the page was reloaded,
        //so the timer can know from which time to start the countdown (continue with the current remaining time and not the initial one)
        // minServiceTime is in Seconds
        var finalDate = new Date(dateFrom != null ? dateFrom : Date.now());

        elem.countdown(finalDate)
        .off('update.countdown').on('update.countdown', function(event) {
            $(this).text(event.strftime('%H:%M:%S'));

        }).off('finish.countdown').on('finish.countdown', function(event) {
            $(this).text("00:00:00");
            $(this).addClass('preparationTimeDone');

        }).off('stop.countdown').on('stop.countdown', function(event) {

        });
    },
	unsubscribeStomp: function(self) {
	    if(self.stompSubscription == null)
	        return;

        self.stompSubscription.unsubscribe();
	    self.stompSubscription = null;
	},
	subscribeToStomp: function(self) {

        if(self.stompSubscription == null) {
            self.stompSubscription = self.client.subscribe('/live/monitors/admin/preparations', function (message) {
                //var responseObject = JSON.parse( message.body );

                // reload all tickets and preparations
                self.collection.getFirstPage();
            });
        }
        // else -> already subscribed
    },
    setListener: function()
    {
        var self = this;


        var headers = {
            //origin: 'https://www.qedis-metro.com', toDo: enable it
        };

        if(this.isConnectedToSocket) {
            self.subscribeToStomp(self);
            return;
        }


        this.client.connect(headers,
            function(frame) {
                self.isConnectedToSocket = true;
                self.subscribeToStomp(self);
            },
            function(onCloseMessage) {
                if(onCloseMessage.indexOf('Whoops! Lost connection to') > -1) {
                    console.log("connection closed");
                }
            }
        );
    },
	successData: function()
	{
		var self = this;
		self.hideActionProgressBar();

		if(this.isFirstDisplay)
		{
			this.isFirstDisplay = false;
			this.render();
            if(this.collection.models.length == 0)
                $('#search-container').hide();
		}

		$('#table-container').html(this.table({ "models" : this.collection.models, pageInfo : this.collection.info()}));

        this.preparationsPopupView = new PreparationsPopupView({
            "submitCallback": this.loadData,
            "view": this
        });

        this.setupCountdownTimers();
        $("#preparationsTicketsContainer .pending-row-customer-addToPreparationList").unbind('click').on('click', function(evt) {
            self.showPreparationPopup(evt, self);
        });

		this.pagination = new Pagination({ collection : this.collection });
		this.pagination.render();
		$( '#pagination' ).html( this.pagination.$el );

        $("#pageSize li").on("click", function() {

            var pageSize = $(this).text();

            if ( ! $(this).hasClass("active")  )
            {
                $("#pageSize li.active").removeClass("active");
                $(this).addClass("active");
                $("#pageSizeBtn").text(pageSize);
                self.collection.state.pageSize = pageSize;

                self.collection.getFirstPage();
            }

        });

		if(this.collection.models.length > 0)
		{
			$('#table-container').show();

			// if it has only one page
			if(this.collection.state.firstPage == this.collection.state.lastPage)
			    $('#pagination').hide();
			else
			    $('#pagination').show();
			$('#empty').hide();

            //self.initializeTrs(this.showHideActionButton, "#dataTables");
		}
		else
		{
			$('#table-container').hide();
			$('#pagination').hide();
			$('#empty').show();
		}

		$("#preparationsTicketsContainer .tableTitle").notify(
		    i18n.t("counter.refreshed"),
            {
                position:"top center",
                className: "info",
                autoHide: true
            }
        );

        //this.clearListener();
        this.setListener(); // stomp listener
	},
	errorData: function(collection, xhr, options)
	{
 		this.onErrorHandler(collection, xhr, options);
	},
	renderTickets: function($ticketsContainer, data) {
	    var self = this;

	    $ticketsContainer.empty();
        for(var i=0; i<data.length; i++)
            $ticketsContainer.append(self.preparationRowPartialTemplate( data[i] ));
	},
	renderSpecificTicket: function($ticketRow, data) {
	    var self = this;

        // if the ticket is a new one, append it after the previous number
	    if($ticketRow == null || $ticketRow.length == 0) {

            if(data) {
                data.animationClass = 'with-animation'; // add an animation class, to highlight the newly updated row

                var $queueTicketsContainer = $("#queue-"+data.queueId);

                // if its the first ticket, append it
                if($queueTicketsContainer.find(".ticketRow").length == 0 || data.number == 1) {
                    $queueTicketsContainer.append(self.preparationRowPartialTemplate(data));

                }else {
                    var $previousTicket = $(".number-" + (data.number - 1));
                    $previousTicket.after(self.preparationRowPartialTemplate(data));
                }
            }
        }else {
            if(data) {
                data.animationClass = 'with-animation'; // add an animation class, to highlight the newly updated row

                // update the current one, by replacing it
                $ticketRow.replaceWith(self.preparationRowPartialTemplate(data));
            }
	    }
	},
	setupCountdownTimers: function() {
	    var self = this;

	    this.bindPreparationCustomersEvents();

        $.each(this.collection.models, function(kVenue, venue) {

            $.each(venue.attributes.queues, function(kQueue, queue) {
                $.each(queue.preparations, function(kPreparation, preparation) {

                    var dateFrom = preparation.date;
                    var elem = $("#preparationsContainer").find('[data-id="'+ preparation.preparationId +'"]').find(".pending-row-customer-timeLeft");

                    self.setCountdownForElement(dateFrom, elem);
                });

            });
        });
	},
	bindPreparationCustomersEvents: function() {
        var self = this;

        $("#preparationsContainer .pending-row-customer-createTicket").unbind("click").on("click", function(evt) {

            var $elem = $(this);

            var preparationId = parseInt($elem.parent().data("preparation-id"));

            if( isNaN(preparationId) ) {
                $elem.notify(i18n.t('preparations.wrongData'), { position:"left center", className: "error" });
                return;
            }

            var foundPreparation = self.findPopupData(evt).preparation;

            if(foundPreparation == null) {
                $(this).notify(i18n.t("server.errorOccurred"),
                {
                    position:"left center",
                    className: "error",
                    autoHide: true
                });

                return;
            }

            $.ajaxDefaultQ({
                url: "rest/api/agent/counters/issueImmediateTicket?preparationId=" + foundPreparation.preparationId,
                type: "POST",
                contentType: "application/json",
                data: {}

            }).done(function(response, status, xhr){

                if(response != null) {

                    var text = "";
                    var className = "";

                    if(response.error != null) {
                        text = i18n.t("server.errorOccurred");
                        className = "error";
                    }
                    else if(response.data == "Success") {
                        text = i18n.t('counter.issuedTicketSuccess');
                        className = "success";

                        setTimeout(function() {
                            self.loadData(self);
                        }, 3000);
                    }
                    else if(response.data == "QueueClosed") {
                        text = i18n.t("counter.queueClosed");
                        className = "info";
                    }
                    else if(response.data == "CustomerDailyLimit") {
                        text = i18n.t("counter.customerDailyLimit");
                        className = "info";
                    }
                    else if(response.data == "QueueDailyLimit") {
                        text = i18n.t("counter.queueDailyLimit");
                        className = "info";
                    }
                    else if(response.data == "CustomerAlreadyHasTicket") {
                        text = i18n.t("counter.customerAlreadyHasTicket");
                        className = "info";
                    }
                    else {
                        text = i18n.t("server.errorOccurred");
                        className = "error";
                    }

                    $elem.notify(text,
                    {
                        position: "left center",
                        className: className,
                        autoHide: true
                    });

                }
                else {
                    $elem.notify(i18n.t("server.errorOccurred"),
                    {
                        position: "left center",
                        className: "error",
                        autoHide: true
                    });

                }

            })
            .fail(function(response) {
                $elem.notify(i18n.t("server.errorOccurred"),
                {
                    position: "left center",
                    className: "error",
                    autoHide: true
                });

            });
        });

    },
    findPopupData: function(e) {
        var self = this;

        var $elem = $(e.currentTarget);
        var ticketId = parseInt($elem.parent().data("ticket-id"));
        var preparationId = parseInt($elem.parent().data("preparation-id"));
        var queueId = parseInt($elem.parent().data("queue-id"));
        var venueId = parseInt($elem.parent().data("venue-id"));

        if( (isNaN(ticketId) && isNaN(preparationId)) || isNaN(queueId) || isNaN(venueId)) {
            $elem.notify(i18n.t('preparations.wrongData'), { position:"left center", className: "error" });
            return;
        }

        var foundVenues = $.grep(self.collection.models, function(venue) {
            return venue.attributes.venueId == venueId;
        });

        if(foundVenues == null || foundVenues.length != 1) {
            $elem.notify(i18n.t('preparations.wrongData'), { position:"left center", className: "error" });
            return;
        }

        var foundQueues = $.grep(foundVenues[0].attributes.queues, function(queue) {
            return queue.queueId == queueId;
        });

        if(foundQueues == null || foundQueues.length != 1) {
            $elem.notify(i18n.t('preparations.wrongData'), { position:"left center", className: "error" });
            return;
        }

        var foundTickets = $.grep(foundQueues[0].tickets, function(ticket) {
            return ticket.id == ticketId;
        });

        var foundPreparations = $.grep(foundQueues[0].preparations, function(preparation) {
            return preparation.id == preparationId;
        });

        if((foundTickets == null || foundTickets.length != 1) && (foundPreparations == null || foundPreparations.length != 1)) {
            $elem.notify(i18n.t('preparations.noSuchTicket'), { position:"left center", className: "error" });
            return;
        }

        return {
            "venue": foundVenues[0],
            "queue": foundQueues[0],
            "ticket": foundTickets.length > 0 ? foundTickets[0] : null,
            "preparation": foundPreparations.length > 0 ? foundPreparations[0] : null
        }
    },
    showPreparationPopup: function(e, self) {
        var data = self.findPopupData(e);

        self.preparationsPopupView.setData(data);
        self.preparationsPopupView.show();
    },
    loadData: function(self) {
        self.collection.getFirstPage();
    },
    clearListener: function() {
        var self = this;

        if(!this.client || !this.isConnectedToSocket)
            return;

        self.unsubscribeStomp(self);

        this.client.disconnect(function() {
            console.log(i18n.t("queue.client_disconnected"));

            this.isConnectedToSocket = false;
        });
    }
});

module.exports = TheView;